<div class="modal-header" style="padding: 15px !important;">
    <h4 class="modal-title" *ngIf="!deleteEvent">Edit recurring event</h4>
    <h4 class="modal-title" *ngIf="deleteEvent">Delete recurring event</h4>
</div>
<div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="submit()" style="margin-top: 15px;margin-left: -18px;">
        <div class="eventType" *ngIf="showThisEventOption">
            <input type="radio" value="this" formControlName="editcalenderevent">
            <span>This Event</span>
        </div>
        <div class="eventType">
            <input type="radio" value="forward" formControlName="editcalenderevent">
            <span>This and Following events</span>
        </div>
        <div class="eventType">
            <input type="radio" value="all" formControlName="editcalenderevent">
            <span>All events</span>
        </div>
        <div class="btn-align center">
            <button type="reset" class="btn btn-default alertbtn alertbtnyes" (click)="onCancel()">Cancel</button>
            <button type="submit" class="btn btn-default alertbtn alertbtnno okbtn" [disabled]="form.invalid">OK</button>
        </div>
    </form>
</div>